export const urlSanityCheck = (url: string) => {
	const sanitisedUrl = url.trim();

	const sanityTest =
		/^((((https?|ftps?):)?\/\/)|((mailto|skype|callto|facetime|git|irc|irc6|news|nntp|feed|cvs|svn|mvn|ssh|itms|notes|smb|hipchat|sourcetree):))[^\s/$.?#].[^\s]*$/i;

	if (sanityTest.test(sanitisedUrl)) {
		return true;
	}
	return false;
};
